/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewdisclaimeren4Inputs */

const en_letterpreviewdisclaimeren4 = /** @type {(inputs: Letterpreviewdisclaimeren4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This letter is friendly communication prepared with the help of ClaimPack. It does not constitute legal advice or formal notification. For the registered admonitory notice and its associated legal effects, consult a lawyer.`)
};

const pt_letterpreviewdisclaimeren4 = /** @type {(inputs: Letterpreviewdisclaimeren4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This letter is friendly communication prepared with the help of ClaimPack. It does not constitute legal advice or formal notification. For the registered admonitory notice and its associated legal effects, consult a lawyer.`)
};

/**
* | output |
* | --- |
* | "This letter is friendly communication prepared with the help of ClaimPack. It does not constitute legal advice or formal notification. For the registered adm..." |
*
* @param {Letterpreviewdisclaimeren4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewdisclaimeren4 = /** @type {((inputs?: Letterpreviewdisclaimeren4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewdisclaimeren4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewdisclaimeren4(inputs)
	return pt_letterpreviewdisclaimeren4(inputs)
});
export { letterpreviewdisclaimeren4 as "letterPreviewDisclaimerEN" }